export const audioBucketUrl = "https://d31dc3uk1vw0n5.cloudfront.net";
export const lambdaUrl = "https://l7htw6vli2.execute-api.us-east-2.amazonaws.com/prod";



// WEBPACK FOOTER //
// ./src/data/config.js